import React, { useMemo } from 'react';
import { useAppDispatch } from 'app/store';
import { addAlertAction } from 'app/store/Alerts/slice';
import { useFetchValidationSchema } from 'app/utils/hooks';
import { transformSchemaToYup } from 'app/utils/schemaToYup';
import { Alert } from 'app/store/Alerts/slice.types';
import { saveReasonForAccountDeleteAction } from 'app/store/Mixpanel/slice';
import { Link } from 'types/api.types';
import { DeleteAccountDialogComponent } from './DeleteAccountDialogComponent';
import { errorMessages } from './validations';
import { defaultValues } from './constants';

interface DeleteAccountDialogProps {
  open: boolean;
  link: Link;
  onClose: () => void;
}

export const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
  open,
  link,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const { validationSchema } = useFetchValidationSchema({ link });

  const yupValidationSchema = useMemo(
    () =>
      validationSchema &&
      transformSchemaToYup(validationSchema, defaultValues, errorMessages),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validationSchema, errorMessages]
  );

  const handleAlertMessages = (alert: Alert) => {
    dispatch(addAlertAction(alert));
  };

  const handleMixpanelEvent = (reason: string) => {
    dispatch(saveReasonForAccountDeleteAction(reason));
  };

  return (
    <DeleteAccountDialogComponent
      validationSchema={yupValidationSchema}
      link={link}
      open={open}
      onClose={onClose}
      handleMessages={handleAlertMessages}
      handleMixpanelEvent={handleMixpanelEvent}
    />
  );
};
